import React from "react"
import "./styles/App.css"
import "./styles/Components.css"
import { Provider } from "mobx-react"
import { useTranslation } from "react-i18next"
import Widget from "./Widget"
import Store from "./stores/Store"
import moment from "moment"
import MomentUtils from "@date-io/moment"
import { MuiPickersUtilsProvider } from "@material-ui/pickers"

import "moment/locale/sl"

function App () {
    var store = new Store()
    const { i18n } = useTranslation()

    moment.locale(i18n.language)

    return (
        <MuiPickersUtilsProvider utils={MomentUtils} locale={i18n.language}>
            <Provider store={store}>
                <Widget />
            </Provider>
        </MuiPickersUtilsProvider>
    )
}

export default App
